exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PeriodicRequest_block_3iLF + .PeriodicRequest_block_3iLF {\n  margin-top: 30px;\n}\n\n.PeriodicRequest_blockTitle_bzQ0 {\n  margin-bottom: 10px;\n\n  font-size: 17px;\n}\n\n.PeriodicRequest_daysInput_3VDq {\n  margin-right: 5px;\n  margin-bottom: 10px;\n  margin-left: 10px;\n\n  display: inline-block;\n\n  width: 50px\n\n  /* перебить стили для китового отступа поля ввода */\n}\n\n.PeriodicRequest_daysInput_3VDq > input {\n  padding: 0 15px !important;\n}\n\n.PeriodicRequest_infoMessage_2Kbz {\n  color: #787878;\n}\n\n.PeriodicRequest_number_1REN {\n  margin: 15px 0\n}\n\n.PeriodicRequest_number_1REN > span {\n  top: 2px;\n}\n\n.PeriodicRequest_formats_3Z5G > div {\n  margin: 15px 0;\n}\n\n.PeriodicRequest_nickname_1pwq {\n  margin-left: 7px;\n\n  font-size: 13px;\n\n  color: #787878;\n}\n\n.PeriodicRequest_actionsDivider_2B7z {\n  margin: 0 15px;\n}\n", ""]);

// exports
exports.locals = {
	"block": "PeriodicRequest_block_3iLF",
	"blockTitle": "PeriodicRequest_blockTitle_bzQ0",
	"daysInput": "PeriodicRequest_daysInput_3VDq",
	"infoMessage": "PeriodicRequest_infoMessage_2Kbz",
	"number": "PeriodicRequest_number_1REN",
	"formats": "PeriodicRequest_formats_3Z5G",
	"nickname": "PeriodicRequest_nickname_1pwq",
	"actionsDivider": "PeriodicRequest_actionsDivider_2B7z"
};